import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { get_main_categories } from "../../../../redux/actions/categories";
import { setAlert } from "../../../../redux/actions/alert";
import SideNav from "../../../../components/dashboard/Sidebar";
import axios from "axios";

function DashboardCategoriesCreate({
  get_main_categories,
  mainCategories,
  setAlert,
}) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    parent: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    parent: "",
  });

  const { name, parent } = formData;

  useEffect(() => {
    get_main_categories();
  }, [get_main_categories]);

  const validateForm = () => {
    let formIsValid = true;
    const newErrors = { name: "", parent: "" };

    if (!name.trim()) {
      newErrors.name = "El nombre de la categoría es obligatorio.";
      formIsValid = false;
    } else if (name.length < 3) {
      newErrors.name = "El nombre debe tener al menos 3 caracteres.";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
      },
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/category/categories/create/`,
        { name, parent },
        config,
      );

      if (response.status === 201) {
        setAlert("Categoría creada correctamente", "green");
        navigate("/dashboard/categories");
      } else {
        setAlert("Error al crear la categoría", "red");
      }
    } catch (err) {
      console.error(err);
      setAlert("Error al crear la categoría", "red");
    }
  };

  return (
    <SideNav>
      <div className="container mx-auto px-4 sm:px-8">
        <h1 className="text-2xl font-semibold text-gray-900 mt-4">
          Crear Categoría
        </h1>
        <div className="mt-8">
          <form onSubmit={onSubmit} className="max-w-3xl mx-auto">
            <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Detalles de la Categoría
              </h3>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Nombre de la Categoría
              </label>
              <div className="mt-1 sm:mt-0 sm:col-span-2">
                <input
                  type="text"
                  name="name"
                  placeholder="Nombre de la categoría"
                  value={name}
                  onChange={onChange}
                  className={`appearance-none block w-full px-3 py-2 border ${
                    errors.name ? "border-red-500" : "border-gray-300"
                  } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`}
                />

                {errors.name && (
                  <p className="mt-1 text-sm text-red-500">{errors.name}</p>
                )}
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
              <label
                htmlFor="parent"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Categoría Principal
              </label>
              <div className="mt-1 sm:mt-0 sm:col-span-2">
                <select
                  name="parent"
                  value={parent || ""}
                  onChange={onChange}
                  className={`appearance-none block w-full px-3 py-2 border ${
                    errors.parent ? "border-red-500" : "border-gray-300"
                  } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`}
                >
                  <option value="">Sin Categoría Principal</option>
                  {mainCategories &&
                    mainCategories.map((mainCategory) => (
                      <option key={mainCategory.id} value={mainCategory.id}>
                        {mainCategory.name}
                      </option>
                    ))}
                </select>
                {errors.parent && (
                  <p className="mt-1 text-sm text-red-500">{errors.parent}</p>
                )}
              </div>
            </div>
            <button
              type="submit"
              className="inline-flex mt-4 float-right items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Crear Categoría
            </button>
          </form>
        </div>
      </div>
    </SideNav>
  );
}

const mapStateToProps = (state) => ({
  mainCategories: state.CategoriesFull.mainCategories,
});

export default connect(mapStateToProps, { get_main_categories, setAlert })(
  DashboardCategoriesCreate,
);
